
import { createSlice } from "@reduxjs/toolkit";
import { getInventoryInvertor } from "../reduxApi/InventoryInvertorReduxApi";

const inventoryInvertorSlice = createSlice({
    name: 'inventoryInvertor',
    initialState: {
        status: 'idel',
        inventoryInvertor: [],
    },
    reducers: {
        deleteInventoryInvertorAction: (state, action) => {
            state.inventoryInvertor = state.inventoryInvertor.filter(item => !action.payload.includes(item?.ROWID));


            
        },
        updateInventoryInvertorAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.inventoryInvertor.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.inventoryInvertor.splice(index, 1, action.payload)
    
            }
        },
        addInventoryInvertorAction: (state, action) => {
            console.log("Adding invertor:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.inventoryInvertor.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInventoryInvertor.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getInventoryInvertor.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing invertor Data", action.payload)
                console.log("testing invertor Data", action.payload.data.inventoryInvertorResp)
                state.inventoryInvertor = action.payload.data.inventoryInvertorResp
;
            })
    }
})
export const { deleteInventoryInvertorAction, updateInventoryInvertorAction, addInventoryInvertorAction } = inventoryInvertorSlice.actions
export default inventoryInvertorSlice.reducer